module.exports = __webpack_public_path__ + "img/wand.03740def.svg";